import { action, makeObservable, observable } from 'mobx';
import {
  IPetModel,
  PetModel,
  PhotoModel,
  ReservationModel,
  SpeciesModel,
} from '@common/models';
import { PetAlerts } from '@common/models/Enums';

export class PotentialVisit {
  petId: number;
  clientId: number;
  name: string;
  photo: PhotoModel;
  species: SpeciesModel;
  rowVersion: string;
  visitSelected: boolean;
  visitIsExpress: boolean;
  @observable visitIsRxOnly: boolean = false;
  @observable visitPetHasReactions: boolean = false;
  visitCanChangeReaction: boolean;
  @observable reservation?: ReservationModel;
  pet: PetModel;
  @observable isWalkingIn: boolean = false;
  @observable isAppointmentTime: boolean = false;

  @action.bound setIsWalkingIn(showWalkingLabel: boolean) {
    this.isWalkingIn = showWalkingLabel;
  }

  @action.bound setIsAppointmentTime(showAppointmentTimeLabel: boolean) {
    this.isAppointmentTime = showAppointmentTimeLabel;
  }

  @action.bound setVisitPetHasReactions(visitPetHasReactions: boolean) {
    this.visitPetHasReactions = visitPetHasReactions;
  }

  @action.bound setVisitIsRxOnly(isRxOnly: boolean) {
    this.visitIsRxOnly = isRxOnly;
  }

  constructor(
    pet: IPetModel,
    reservation?: ReservationModel,
    visitPetHasReactions?: boolean,
    visitIsRxOnly?: boolean
  ) {
    this.pet = new PetModel(pet);
    this.petId = pet.petId;
    this.clientId = pet.clientId;
    this.name = pet.name;
    this.photo = pet.photo!;
    this.species = pet.species!;
    this.rowVersion = pet.rowVersion;

    this.visitSelected = false;
    this.visitIsExpress = false;
    this.visitIsRxOnly = visitIsRxOnly ?? false;
    this.visitPetHasReactions = visitPetHasReactions ?? false;
    this.visitCanChangeReaction = !this.pet.petAlerts?.some(
      (x) => x.petAlertId === PetAlerts.VaccineReaction,
    );

    this.reservation = reservation;

    this.isWalkingIn = false;
    this.isAppointmentTime = false;

    makeObservable(this);
  }
}
